import Utils from "../../../utility";

const initialState = {
  brandOwnerList: [],
  propertyOwner: [],
  brands: [],
  order: "DESC",
  sortField: "addDate",
  offset: 1,
  take: 20,
  detailBrandOwner: {},
  search: "",
  count: 0,
};
export const brandOwnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${Utils.ActionName.BRAND_OWNER}`:
      return {
        ...state,
        ...action.payload,
      };
    case `${Utils.ActionName.RESET_BRAND_OWNER}`:
      return initialState;
    default:
      return { ...state };
  }
};
